import { client } from '@canvas/rovo-content-bridge-api';

export const WHITEBOARDS_CLIENT_ID = client('confluence-whiteboards');

export const CONFLUENCE_AFM_CLIENT_ID = client('confluence-afm');
